<template>
  <form @submit.prevent="handleSubmit" class="space-y-5">
    <input
      type="email"
      v-model="email"
      placeholder="El. paštas"
      class="input input-lg w-full"
      autocomplete="email"
      required
    />

    <input
      type="password"
      v-model="password"
      placeholder="Slaptažodis"
      class="input input-lg w-full"
      autocomplete="current-password"
      required
    />

    <label class="flex items-center gap-2 text-sm text-base-content/70">
      <input type="checkbox" id="remember" class="checkbox checkbox-sm" />
      Prisiminti
    </label>

    <div v-if="error" role="alert" class="alert alert-error alert-soft text-sm">
      {{ error }}
    </div>

    <button
      type="submit"
      class="btn btn-primary btn-lg w-full"
      :disabled="isLoading"
    >
      {{ isLoading ? "Jungiamasi..." : "Prisijungti" }}
    </button>
  </form>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const authStore = useAuthStore();

const email = ref("");
const password = ref("");
const error = ref("");
const isLoading = ref(false);

const handleSubmit = async () => {
  try {
    error.value = "";
    isLoading.value = true;
    await authStore.login({
      email: email.value,
      password: password.value,
    });

    // Role-based destination is decided by the router guard
    router.push("/");
  } catch (err) {
    error.value = "Prisijungti nepavyko";
  } finally {
    isLoading.value = false;
  }
};
</script>
